export const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

export function authHeaders(extraHeaders = {}) {
  const token = localStorage.getItem("fb_token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extraHeaders,
  };
}

function showNetworkToast() {
  window.dispatchEvent(new CustomEvent("foody-error", { detail: "Connection error — check your internet" }));
}

export async function authFetch(url, options = {}) {
  const token = localStorage.getItem("fb_token");
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  try {
    const res = await fetch(url, { ...options, headers });
    if (res.status === 401) {
      window.dispatchEvent(new CustomEvent("foody-logout"));
    }
    return res;
  } catch (e) {
    console.error("Network request failed:", url, e);
    showNetworkToast();
    throw e;
  }
}
